export function JsonToURLParameters(json, url) {
    Object.keys(json).forEach((key) => {
        url = url.replace(":" + key, json[key])
    })
    return url
}